export default __webpack_public_path__ + "92194a59fd998e9e1bb8bbb17a0408c3.png";